module.exports = __webpack_public_path__ + "img/flower-tulip.ff42bf17.svg";